require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2017-01-05-using-git-for-docs.json") })
        }
      }, "path---blog-2017-01-05-using-git-for-docs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2017-01-05-using-git-for-docs!./.cache/json/blog-2017-01-05-using-git-for-docs.json
// module id = 332
// module chunks = 231608221292675